/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_Step_NextInputs */

const en_scrape_router_step_next = /** @type {(inputs: Scrape_Router_Step_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next scraper`)
};

const zh_hans1_scrape_router_step_next = /** @type {(inputs: Scrape_Router_Step_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个抓取器`)
};

const pt_br2_scrape_router_step_next = /** @type {(inputs: Scrape_Router_Step_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo scraper`)
};

const es_scrape_router_step_next = /** @type {(inputs: Scrape_Router_Step_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente scraper`)
};

const fr_scrape_router_step_next = /** @type {(inputs: Scrape_Router_Step_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scraper suivant`)
};

const de_scrape_router_step_next = /** @type {(inputs: Scrape_Router_Step_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächster Scraper`)
};

const ru_scrape_router_step_next = /** @type {(inputs: Scrape_Router_Step_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий скрапер`)
};

const it_scrape_router_step_next = /** @type {(inputs: Scrape_Router_Step_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scraper successivo`)
};

/**
* | output |
* | --- |
* | "Next scraper" |
*
* @param {Scrape_Router_Step_NextInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_step_next = /** @type {((inputs?: Scrape_Router_Step_NextInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_Step_NextInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_step_next(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_step_next(inputs)
	if (locale === "es") return es_scrape_router_step_next(inputs)
	if (locale === "fr") return fr_scrape_router_step_next(inputs)
	if (locale === "de") return de_scrape_router_step_next(inputs)
	if (locale === "ru") return ru_scrape_router_step_next(inputs)
	if (locale === "it") return it_scrape_router_step_next(inputs)
	return en_scrape_router_step_next(inputs)
});